module.exports = __webpack_public_path__ + "img/Skirt-Back-B3-Da-Ga-Ha-Ia.309acef6.png";